import { useSelector } from 'react-redux';

import { CacheProvider } from '@emotion/react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import createEmotionCache from 'utils/createEmotionCache';

// ==============================|| APP ||============================== //

const emotionCache = createEmotionCache();

const App = () => {
    const customization = useSelector((state) => state.customization);

    return (
        <CacheProvider value={emotionCache}>
            <StyledEngineProvider>
                <ThemeProvider theme={themes(customization)}>
                    <CssBaseline />
                    <NavigationScroll>
                        <Routes />
                    </NavigationScroll>
                    <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick pauseOnHover theme={customization?.navType === 'dark' ? 'dark' : 'light'} />
                </ThemeProvider>
            </StyledEngineProvider>
        </CacheProvider>
    );
};

export default App;
